export default "__VITE_ASSET__gt8k0dfK__"